/** @format */
import { CommonModule } from '@angular/common';
import { ExtremelyLowStockLayerComponent } from 'libs/pdp/add-to-cart/components/src/lib/extremely-low-stock-layer/extremely-low-stock-layer.component';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { SideNavModule } from '@shared/components';

@NgModule({
	declarations: [ExtremelyLowStockLayerComponent],
	imports: [
		CommonModule,
		HmfButtonComponent,
		SideNavModule],
	exports: [ExtremelyLowStockLayerComponent]
})
export class ExtremelyLowStockLayerModule {}
